import { Injectable } from '@angular/core';
import { ContactSummaryModel } from 'app/models/dms/contact.model';
import { VehicleSummaryModel } from 'app/models/dms/vehicle.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService
{

  public contactMessage = new Subject<ContactSummaryModel>();
  public vehicleMessage = new Subject<VehicleSummaryModel>();

  constructor() { }

}
